import { render, staticRenderFns } from "./WindControlBlackList.vue?vue&type=template&id=70d33f27&"
import script from "./WindControlBlackList.vue?vue&type=script&lang=js&"
export * from "./WindControlBlackList.vue?vue&type=script&lang=js&"
import style0 from "./WindControlBlackList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports